/**
 * Подключаем Vue библиотеки
 */
App.vue.setComponent(require('vue3-perfect-scrollbar').PerfectScrollbar); // name PerfectScrollbar
// App.vue.setComponent(require('hooper').Hooper); // name Hooper
// App.vue.setComponent(require('hooper').Slide);  // name HooperSlide
// App.vue.setComponent(require('hooper').Pagination);  // name HooperPagination
// App.vue.setComponent(require('hooper').Navigation);  // name HooperNavigation
// App.vue.setComponent(require('vue-slide-up-down').default); // name SlideUpDown
// App.vue.setComponent(require('vue-owl-carousel2')); // name VOwlCarousel2

/**
 * Место подключение компонентов с глобальными данными, важно помнить что очередность важна
 */
App.vue.setComponent(require('./components/menus/vue-menu/vue-menu.vue').default);

/**
 * Подключение обычных компонентов
 */
App.vue.setComponent(require('./components/def/def-checkbox/def-checkbox.vue').default);
// App.vue.setComponent(require('./components/modals/enter/registration-type.vue').default);
// App.vue.setComponent(require('./components/modals/modal-registration.vue').default);
// App.vue.setComponent(require('./components/modals/enter/enter-type.vue').default);
// App.vue.setComponent(require('./components/modals/enter/modal-password-recovery.vue').default);
// App.vue.setComponent(require('./components/modals/enter/modal-enter-header.vue').default);
// App.vue.setComponent(require('./components/cabinet/enter-cabinet/enter-cabineqqt.vue').default);

App.vue.setComponent(require('./components/menus/menu-mobile.vue').default);
App.vue.setComponent(require('./components/bootstrap/preloader.vue').default);
App.vue.setComponent(require('./components/menus/vue-menu/vue-menu-desktop.vue').default);
App.vue.setComponent(require('./components/menus/vue-menu/vue-menu-mobile.vue').default);
App.vue.setComponent(require('./components/bootstrap/search-engine-top.vue').default);
App.vue.setComponent(require('./components/bootstrap/search-engine.vue').default);
App.vue.setComponent(require('./components/bootstrap/share.vue').default);

// App.vue.setComponent(require('./components/def/def-input/def-input.vue').default);
// App.vue.setComponent(require('./components/def/def-phone/def-phone.vue').default);
// App.vue.setComponent(require('./components/def/def-email/def-email.vue').default);
App.vue.setComponent(require('./components/def/def-select/def-select.vue').default);
App.vue.setComponent(require('./components/def/def-select-wrapper/def-select-wrapper.vue').default);
App.vue.setComponent(require('./components/def/def-autocomplete/def-autocomplete.vue').default);
App.vue.setComponent(require('./components/def/DefZoom/DefZoom.vue').default);
App.vue.setComponent(require('./components/checkout/new-post-office/new-post-office.vue').default);
App.vue.setComponent(require('./components/def/DefLabels/DefLabels.vue').default);

App.vue.setComponent(require('./components/bootstrap/favourite.vue').default);
App.vue.setComponent(require('./components/forms/quick-view-form.vue').default);
App.vue.setComponent(require('./components/modals/addToBasketModal.vue').default);

App.vue.setComponent(require('./components/sliders/MainSlider.vue').default);

App.vue.setComponent(require('./components/def/DefCounter/DefCounter.vue').default);
App.vue.setComponent(require('./components/bootstrap/drop-down.vue').default);
App.vue.setComponent(require('./components/Catalog/sku-select.vue').default);
App.vue.setComponent(require('./components/def/def-like.vue').default);
App.vue.setComponent(require('./components/Catalog/SelectVueSort.vue').default);
App.vue.setComponent(require('./components/Catalog/filter/FilterBlock.vue').default);
App.vue.setComponent(require('./components/Catalog/filter/CancelFilterInline.vue').default);
App.vue.setComponent(require('./components/Catalog/filter/CancelFilter.vue').default);
App.vue.setComponent(require('./components/Catalog/filter/CatalogFilter.vue').default);
App.vue.setComponent(require('./components/bootstrap/Pagination.vue').default);
App.vue.setComponent(require('./components/vue-popup/vue-popup.vue').default);
App.vue.setComponent(require('./components/product-detail/product-detail.vue').default);
App.vue.setComponent(require('./components/Catalog/Catalog.vue').default);
App.vue.setComponent(require('./components/Catalog/catalog-page-top-banner.vue').default);
App.vue.setComponent(require('./components/card/product-card/ProductCard.vue').default);
App.vue.setComponent(require('./components/Catalog/ProductsList.vue').default);
App.vue.setComponent(require('./components/card/product-card/product-card-2.vue').default);
App.vue.setComponent(require('./components/card/jewelry-card/jewelry-card.vue').default);

App.vue.setComponent(require('./components/sliders/NewGoods.vue').default);
App.vue.setComponent(require('./components/sliders/SameGoods.vue').default);
App.vue.setComponent(require('./components/sliders/CheckedGoods.vue').default);
App.vue.setComponent(require('./components/sliders/Bestsellers.vue').default);
App.vue.setComponent(require('./components/sliders/JewelrySlider.vue').default);
App.vue.setComponent(require('./components/forms/NewsSubscribe.vue').default);
App.vue.setComponent(require('./components/pages/page-blog.vue').default);
App.vue.setComponent(require('./components/pages/page-holidays.vue').default);
App.vue.setComponent(require('./components/def/def-table-size/def-table-size.vue').default);
App.vue.setComponent(require('./components/card/choice-ring-card/choice-ring-card.vue').default);
App.vue.setComponent(require('./components/sliders/choice-ring.vue').default);
App.vue.setComponent(require('./components/card/news-card/news-card.vue').default);
App.vue.setComponent(require('./components/pages/page-news.vue').default);

App.vue.setComponent(require('./components/checkout/checkout-goods/checkout-goods.vue').default);
// App.vue.setComponent(require('./components/Checkout/checkout-step/checkout-step.vue').default);
App.vue.setComponent(require('./components/checkout/checkout-information/checkout-information.vue').default);
App.vue.setComponent(require('./components/checkout/checkout-confirmation/checkout-confirmation.vue').default);
App.vue.setComponent(require('./components/checkout/sale-order-ajax.vue').default);
App.vue.setComponent(require('./components/checkout/checkout-person-type.vue').default);
App.vue.setComponent(require('./components/checkout/checkout-delivery.vue').default);
App.vue.setComponent(require('./components/checkout/checkout-pay-system.vue').default);
App.vue.setComponent(require('./components/checkout/checkout-user-properties').default);
App.vue.setComponent(require('./components/banners/banner-thanks.vue').default);
App.vue.setComponent(require('./components/pages/checkout-thanks.vue').default);
App.vue.setComponent(require('./components/card/sale-card/sale-card.vue').default);

App.vue.setComponent(require('./components/bootstrap/time-remaining.vue').default);
App.vue.setComponent(require('./components/card/sale-card/sale-card-counter.vue').default);
App.vue.setComponent(require('./components/pages/page-sale.vue').default);
App.vue.setComponent(require('./components/Catalog/catalog-aside-menu.vue').default);
App.vue.setComponent(require('./components/bootstrap/date-select.vue').default);
App.vue.setComponent(require('./components/bootstrap/date-picker.vue').default);

App.vue.setComponent(require('./components/contacts/contacts').default);
App.vue.setComponent(require('./components/breadcrumb/breadcrumb').default);
App.vue.setComponent(require('./components/contacts/contact-card').default);


App.vue.setComponent(require('./components/basket/basket-elements/order-coupon.vue').default);

/** modals **/
// App.vue.setComponent(require('./components/modals/modal-enter.vue').default);
// App.vue.setComponent(require('./components/modals/user-info-form.vue').default);
App.vue.setComponent(require('./components/modals/main-modal.vue').default);
// App.vue.setComponent(require('./components/modals/modal-contacts.vue').default);
// App.vue.setComponent(require('./components/modals/thankyou-page.vue').default);
App.vue.setComponent(require('./components/modals/favourite-modal/favourite-modal-delete').default);
App.vue.setComponent(require('./components/modals/favourite-modal/favourite-modal-move').default);
App.vue.setComponent(require('./components/modals/modal-wrapper.vue').default);
App.vue.setComponent(require('./components/Catalog/modal/thanks-for-application.vue').default);


App.vue.setComponent(require('./components/modals/modal-wrapper.vue').default);
App.vue.setComponent(require('./components/cabinet/cabinet-menu.vue').default);
App.vue.setComponent(require('./components/cabinet/cabinet-select-item.vue').default);
App.vue.setComponent(require('./components/cabinet/favorites-vue.vue').default);
App.vue.setComponent(require('./components/cabinet/edit-favorite-item').default);
App.vue.setComponent(require('./components/cabinet/delete-favorite-item').default);
App.vue.setComponent(require('./components/cabinet/Personal/personal.vue').default);
App.vue.setComponent(require('./components/cabinet/Personal/PersonalSubscribes.vue').default);
App.vue.setComponent(require('./components/cabinet/cabinet-history-item.vue').default);
App.vue.setComponent(require('./components/cabinet/cabinet-history.vue').default);
App.vue.setComponent(require('./components/cabinet/cabinet.vue').default);
// App.vue.setComponent(require('./components/modals/sms-confirmation.vue').default);




/**
 * SOVA
 */

/** product **/
App.vue.setComponent(require('./components/Product/GetToday/GetToday.vue').default);
App.vue.setComponent(require('./components/Product/GetToday/GetTodayList.vue').default);
App.vue.setComponent(require('./components/Product/GetToday/GetTodayListStore.vue').default);
App.vue.setComponent(require('./components/Product/GetToday/GetTodayListTabs.vue').default);
App.vue.setComponent(require('./components/Product/GetToday/GetTodayDetail.vue').default);
App.vue.setComponent(require('./components/Product/ProductModal.vue').default);
App.vue.setComponent(require('./components/Product/sliders/PackageBanner.vue').default);
App.vue.setComponent(require('./components/Product/ProductPromotion.vue').default);
// IPost
App.vue.setComponent(require('./components/Product/ProductIPost/ProductIPost.vue').default);
App.vue.setComponent(require('./components/Product/ProductIPost/IPostModal.vue').default);
// Kits
App.vue.setComponent(require('./components/Product/ProductKits/ProductKits.vue').default);
App.vue.setComponent(require('./components/Product/ProductKits/ProductKitsCard/ProductKitsCard.vue').default);
App.vue.setComponent(require('./components/Product/ProductKits/ProductKitsTotal/ProductKitsTotal.vue').default);
App.vue.setComponent(require('./components/Product/ProductKits/ProductKitsModal/ProductKitsModal.vue').default);
App.vue.setComponent(require('./components/Product/ProductKits/ProductKitsModal/ProductKitsModalCard.vue').default);
App.vue.setComponent(require('./components/Product/ProductKits/ProductKitsModal/SkuKit.vue').default);
App.vue.setComponent(require('./components/Product/ProductKits/ProductKitsBottom.vue').default);

/** cabinet **/
App.vue.setComponent(require('./components/cabinet/change-phone').default);
App.vue.setComponent(require('./components/cabinet/registration-control/registration-control.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/enter-cabinet.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/sms-confirmation.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/enter-cabinet-nav.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/enter-cabinet-header.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/enter-cabinet-main-btn.vue').default);
// App.vue.setComponent(require('./components/cabinet/validate-user-phone/validate-user-phone.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/validate-phone-modal.vue').default);

/** def **/
App.vue.setComponent(require('./components/def/def-input/def-input.vue').default);
// App.vue.setComponent(require('./components/def/def-phone/def-phone.vue').default);
App.vue.setComponent(require('./components/def/def-email/def-email.vue').default);
App.vue.setComponent(require('./components/def/DefLang/DefLang.vue').default);
App.vue.setComponent(require('./components/def/DefPicture/DefPicture.vue').default);
App.vue.setComponent(require('./components/def/DefVideo/DefVideo.vue').default);
App.vue.setComponent(require('./components/def/DefInsertTilda/DefInsertTilda.vue').default);
App.vue.setComponent(require('./components/def/DefProgramMe/DefProgramMe.vue').default);
App.vue.setComponent(require('./components/def/DefBuyOneClick/DefBuyOneClickThanks.vue').default);

/** modals **/
App.vue.setComponent(require('./components/modals/forgot-password/forgot-password').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/registration-phone.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/registration-email.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/enter-cabinet-choose.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/authentication-phone.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/authentication-email.vue').default);
App.vue.setComponent(require('./components/modals/enter-cabinet/enter-cabiner-errors.vue').default);

/** sliders **/
App.vue.setComponent(require('./components/sliders/DefSliderWrapper.vue').default);
App.vue.setComponent(require('./components/sliders/CardSlider.vue').default);
App.vue.setComponent(require('./components/sliders/ProductSlider.vue').default);
App.vue.setComponent(require('./components/sliders/WhyLoveYou.vue').default);

/** basket **/
App.vue.setComponent(require('./components/basket/SmallBasket/SmallBasket.vue').default);
App.vue.setComponent(require('./components/basket/SmallBasket/SmallBasketItem.vue').default);
App.vue.setComponent(require('./components/basket/Basket.vue').default);
App.vue.setComponent(require('./components/basket/basket-elements/OrderTotal.vue').default);
App.vue.setComponent(require('./components/basket/basket-elements/BasketCard/BasketCard.vue').default);
App.vue.setComponent(require('./components/basket/basket-elements/buy-one-click.vue').default);

/** core modals **/
App.vue.setComponent(require('./components/def/DefModal/DefModal.vue').default);
App.vue.setComponent(require('./components/def/DefModal/DefModalContainer.vue').default);

/** text **/
// App.vue.setComponent(require('./components/def/DefTitle/DefTitle.vue').default);

/** checkout **/
App.vue.setComponent(require('./components/Checkout/Checkout.vue').default);
App.vue.setComponent(require('./components/Checkout/CheckoutLogIn.vue').default);
App.vue.setComponent(require('./components/Checkout/CheckoutHeader.vue').default);
/** thank you page **/
App.vue.setComponent(require('./components/Checkout/Thanks/ThanksController.vue').default);

/** cities **/
App.vue.setComponent(require('./components/Cities/Cities.vue').default);
/** shops **/
App.vue.setComponent(require('./components/Shops/Shops.vue').default);


/** subscribe **/
App.vue.setComponent(require('./components/def/DefSubscribe/DefSubscribe.vue').default);
App.vue.setComponent(require('./components/modals/ShoppingPresent.vue').default);
App.vue.setComponent(require('./components/modals/ShoppingPresentSuccess.vue').default);

/** Footer **/
App.vue.setComponent(require('./components/Footer/Footer.vue').default);
